import React, { useState, useEffect } from 'react';
import presetApi from '@services/presetApi.jsx';

const PresetPaymentLoadingSetting = ({ preset }) => {
    const [isLoading, setIsLoading] = useState(false);

    const searchParams = new URLSearchParams(location.search);
    const presetId = searchParams.get('presetId');
    const [presetPaymentLoadingPage, setPresetPaymentLoadingPage] = useState(null);

    // 저장 이벤트 리스너 (페이지 상위 컴포넌트에서 저장 요청 시 실행)
    useEffect(() => {
        const eventName = `savePagePreset_payment_loading`;

        const saveHandler = async (event) => {
            if (!preset?.id) {
                alert("프리셋 정보가 없습니다.");
                return;
            }

            try {
                setIsLoading(true);

                // 최소한의 데이터만 전송 (주로 updateBy, updateAt 갱신용)
                const dataToSave = {
                    presetId: event.detail.presetId,
                    isActive: true
                };
                
                const response = await presetApi.savePaymentLoadingPage(event.detail.presetId, dataToSave);

                // 성공 alert 제거 - 상위 컴포넌트에서 일괄 처리
                console.log("결제 로딩 페이지 저장 성공:", response);

                // 저장 후 최신 데이터로 화면 갱신
                if (response) {
                    setPresetPaymentLoadingPage(response);
                }

            } catch (error) {
                console.error("결제 로딩 페이지 저장 실패:", error);
                // 에러만 개별적으로 alert
                alert("결제 로딩 페이지 저장 중 오류가 발생했습니다.");
            } finally {
                setIsLoading(false);
            }
        };

        document.addEventListener(eventName, saveHandler);

        return () => {
            document.removeEventListener(eventName, saveHandler);
        };
    }, [preset?.id]);

    return (
        <div className="preset-settings">
            {/* 기존의 빈 구조 유지 - 추가 저장 항목 없음 */}
        </div>
    );
};

export default PresetPaymentLoadingSetting;
